import api from './index'
import request from '@/utils/request'
/**
 * @description 获取模板管理列表
 */
export function getTemplateManagementList (data) {
  return request({
    url: `${api.getTemplateManagementList}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取商户默认成本
 */
export function getMcFee (data) {
  return request({
    url: `${api.getMcFee}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取商户默认成本
 */
export function getMACost (params) {
  return request({
    url: `${api.getMACost}`,
    method: 'get',
    params
  })
}
/**
 * @description 更改费率模板使用状态
 */
export function templateChangeStatus (data) {
  return request({
    url: `${api.templateChangeStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 删除费率模板
 */
export function templateDelete (data) {
  return request({
    url: `${api.templateDelete}`,
    method: 'post',
    data
  })
}
/**
 * @description 新增费率模板
 */
export function templateAdd (data) {
  return request({
    url: `${api.templateAdd}`,
    method: 'post',
    data
  })
}
/**
 * @description 修改费率模板
 */
export function templateUpdate (data) {
  return request({
    url: `${api.templateUpdate}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取下载中心列表
 */
export function downloadRecord (data) {
  return request({
    url: `${api.downloadRecord}`,
    method: 'post',
    data
  })
}
/**
 * @description 下载中心-下载导出文件
 */
export function downloadFile (data) {
  return request({
    url: `${api.downloadFile}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}
/**
 * @description 删除下载中心导出记录
 */
export function removeDownload (data) {
  return request({
    url: `${api.removeDownload}`,
    method: 'post',
    data
  })
}

// 加盟商管理模块

/**
 * @description 加盟商列表
 */
export function getPartnerList (data) {
  return request({
    url: `${api.getPartnerList}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取加盟商详情
 */
export function getPartnerDetail (params) {
  return request({
    url: `${api.getPartnerDetail}`,
    method: 'get',
    params
  })
}
/**
 * @description 新增加盟商
 */
export function addPartner (data) {
  return request({
    url: `${api.addPartner}`,
    method: 'post',
    data
  })
}
/**
 * @description 编辑加盟商
 */
export function modifyPartner (data) {
  return request({
    url: `${api.modifyPartner}`,
    method: 'post',
    data
  })
}
/**
 * @description 创建加盟商获取手机验证码
 */
export function getCreateSmsCode (params) {
  return request({
    url: `${api.getCreateSmsCode}`,
    method: 'get',
    params
  })
}
/**
 * @description 更换手机号获取手机验证码
 */
export function getChangeSmsCode (params) {
  return request({
    url: `${api.getChangeSmsCode}`,
    method: 'get',
    params
  })
}
/**
 * @description 更换手机号提交
 */
export function submitPhone (data) {
  return request({
    url: `${api.submitPhone}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取可选品牌列表接口
 */
export function getSelectBrandList (params) {
  return request({
    url: `${api.getSelectBrandList}`,
    method: 'get',
    params
  })
}

/**
 * @description 获取可选品牌列表接口
 */
export function getZoneLayerList (params) {
  return request({
    url: `${api.getZoneLayerList}`,
    method: 'get',
    params
  })
}
